import React from 'react';
import {
  HeroContainer,
  LeftContainer,
  RightContainer,
  ContentWrapper,
  Title,
  Description,
  CTAButton
} from './styles';
import { trackFacebookEvent } from '../../../utils/metaPixels';

const ProducerHero = () => {

  const handleCTAClick = () => {
    trackFacebookEvent({
      event: 'Lead',
      content_name: 'Quiero aumentar mis ventas ahora',
      page: window.location.pathname
    });

    window.open(process.env.REACT_APP_URL_SYS_PRODUCTOR + '/floqss/#/login', '_blank');
  };
  return (
    <HeroContainer>
      <LeftContainer>
        <ContentWrapper>
          <Title>Vende a los 23,37 millones que el resto del mercado ignora.</Title>
          <Description>
            Más de 23,37 millones de colombianos no compran cursos online por falta de tarjeta o desconfianza.
            Floqss elimina esa barrera con pagos en efectivo, contraentrega y soporte local.
            Con un solo clic, conectamos tus infoproductos con quienes nunca antes tuvieron acceso.
          </Description>
          <CTAButton
            onClick={handleCTAClick}
          >Quiero aumentar mis ventas ahora</CTAButton>
        </ContentWrapper>
      </LeftContainer>
      <RightContainer />
    </HeroContainer>
  );
};

export default ProducerHero;